import joi, { type AnySchema } from 'joi'
import { AuthenticationReason } from '@mc-alberta/types'

const getDpaSchema = (j: AnySchema, altKey: string) =>
  j.when('authenticationReasons', {
    is: joi.array().items(joi.string().valid('TRANSACTION_AUTHENTICATION')),
    then: joi.when(altKey, {
      not: joi.exist(),
      then: joi.required(),
      otherwise: joi.optional()
    }),
    otherwise: joi.optional()
  })

const addressSchema = joi
  .object({
    addressId: joi.string().guid(),
    name: joi.string(),
    line1: joi.string(),
    line2: joi.string(),
    line3: joi.string(),
    city: joi.string(),
    state: joi.string(),
    zip: joi.string().required(),
    countryCode: joi.string().required().length(2)
  })
  .options({ allowUnknown: true })

const schema = joi
  .object({
    authenticationReasons: joi
      .array()
      .required()
      .items(
        joi
          .string()
          .valid(
            AuthenticationReason.CARD_VERIFICATION,
            AuthenticationReason.CONSUMER_IDENTITY_VALIDATION,
            AuthenticationReason.ENROL_FINANCIAL_INSTRUMENT,
            AuthenticationReason.TRANSACTION_AUTHENTICATION,
            AuthenticationReason.AUTHENTICATOR_REGISTRATION
          )
      ),
    srcDpaId: getDpaSchema(joi.string().required(), 'dpaData'),
    dpaData: getDpaSchema(
      joi
        .object({
          dpaName: joi.string().required()
        })
        .options({ allowUnknown: true }),
      'srcDpaId'
    ),
    dpaTransactionOptions: joi
      .object({
        transactionAmount: joi
          .object({
            transactionAmount: joi.number().min(0).required(),
            transactionCurrencyCode: joi.string().length(3).required()
          })
          .options({ allowUnknown: true }),
        threeDsInputData: joi
          .object({
            billingAddress: addressSchema,
            shippingAddress: addressSchema,
            forceChallenge: joi.boolean()
          })
          .options({ allowUnknown: true }),
        dpaLocale: joi.string().regex(/^[a-z]{2}(-|_)[a-z]{2}$/i)
      })
      .when('authenticationReasons', {
        is: joi
          .array()
          .items(joi.string().valid('CARD_VERIFICATION', 'TRANSACTION_AUTHENTICATION')),
        then: joi.object({
          transactionAmount: joi.required()
        })
      })
      .options({ allowUnknown: true })
      .required(),
    acquirerMerchantId: joi.string(),
    acquirerBIN: joi.string()
  })
  .options({ allowUnknown: true })

export default schema
